export const COOKIE_DEFAULT_VALUE = '(not set)';
